var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRow',[_c('CCol',[_c('CCard',[_c('CCardHeader',[_vm._v(" "+_vm._s(_vm.$t('cert.MyCertificate'))+" ")]),_c('CCardBody',[_c('cert')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }